import * as S from './styled'

import Avatar from '../Avatar'
import { EvaluationUser } from '@app/evaluation-core/types'
import React from 'react'

interface EvalTabItemProps {
  item: string
  active: boolean
  activeUsers?: EvaluationUser[]
  onPress: () => void
  sideBarCollapsed?: boolean
}

const EvalTabItem = ({
  item,
  active,
  activeUsers,
  onPress,
  sideBarCollapsed,
}: EvalTabItemProps) => {
  const isPhone = window.innerWidth <= 767
  const Container = isPhone ? S.MobileEvalSideBarTabItem : S.EvalSideBarTabItem
  return (
    <Container
      className={`eval-sidebar-btn ${active ? 'active' : ''}`}
      style={{ position: 'relative' }}
      sideBarCollapsed={sideBarCollapsed}
    >
      <a onClick={onPress}>{item}</a>
      {!sideBarCollapsed && (
        <div
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            display: 'flex',
            flexDirection: 'row-reverse',
            alignItems: 'center',
            height: '100%',
            background: 'rgba(255,255,255,.5)',
            paddingRight: !isPhone ? 8 : 4,
            paddingLeft: !isPhone ? 8 : 4,
            minWidth: !isPhone ? '25px' : '12.5px',
          }}
        >
          {activeUsers?.map((user, i) => (
            <Avatar
              key={i}
              userId={user.view.email}
              size={!isPhone ? 20 : 10}
              userIndicatorSize={!isPhone ? 6 : 3}
              isLastIndex={i + 1 === activeUsers.length}
              userColor={user.view.color}
              zIndex={i}
            />
          ))}
        </div>
      )}
      {sideBarCollapsed && (
        <div
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            display: 'flex',
            flexDirection: 'row-reverse',
            alignItems: 'center',
            paddingRight: !isPhone ? 2 : 1,
            paddingLeft: !isPhone ? 2 : 1,
            height: '100%',
          }}
        >
          {activeUsers?.map((user, i) => (
            <div
              style={{
                height: !isPhone ? 10 : 5,
                width: !isPhone ? 10 : 5,
                borderRadius: !isPhone ? 25 : 12.5,
                background: user.view.color,
              }}
              key={i}
            />
          ))}
        </div>
      )}
    </Container>
  )
}

export default EvalTabItem
